<template>
  <div class="tooltip" :data-tip="downloadButtonTooltip">
    <a
      :href="firmware.downloadUrl ?? ''"
      class="btn btn-accent w-full join-item"
      :class="[
        firmware.downloadUrl == null ? 'btn-disabled' : '',
        small ? '' : 'min-w-[10rem]',
      ]"
    >
      <Icon icon="ic:baseline-download" class="mr-2 text-lg" />
      {{ small ? "" : "Download" }}
    </a>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { err } from "@/utils";
import { useFirmwareStore } from "@/stores";

defineProps<{
  small?: boolean;
}>();

const firmware = useFirmwareStore();

const downloadButtonTooltip = computed(() => {
  if (firmware.downloadUrl == "") return err("Compile the firmware first");
  return "Download keyboard firmware";
});
</script>
